import {
  BankOutlined,
  FileTextOutlined,
  TeamOutlined,
  UploadOutlined,
  UserOutlined,
} from '@ant-design/icons'
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Tabs,
  Tag,
  Tooltip,
  Upload,
  message,
} from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { AppTable } from '../../../../components/AppTable/AppTable'
import DraggerUploadButton from '../../../../components/Common/DraggerUploadButton'
import RichEditor from '../../../../components/RichEditor/RichEditor'
import SelectPeoplePopup from '../../../../components/SelectPeoplePopup'
import {
  ASSIGNEE_TYPE,
  DATE_FORMAT_LIST,
  ISO_DATE_FORMAT,
  MODES,
  PROPOSAL_STATUS,
  SHIFTS,
} from '../../../../constants'
import { submissionMenu } from '../ProposalPage/ProposalPage'
import ProposalStepApproveV2 from './ProposalStepApproveV2'
import { blue } from '../../../../color'
import { SelectList } from '../../../MissionCreatePage/MissionCreatePageStyled'
import { AvatarHasName } from '../../../../components/Common/Avatar'

const { RangePicker } = DatePicker
const { Option, OptGroup } = Select

const currentStep = 0
const OtherSubmissionFormV2 = props => {
  const {
    proposalStore,
    fileStore,
    loadingAnimationStore,
    authenticationStore,
    contentTemplateStore,
    selectPeopleStore,
    approvalTemplateStore,
    proposalTypeStore,
  } = props

  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
  } = selectPeopleStore

  const history = useHistory()

  const [fileList, setFileList] = useState([])

  const [proposalTypes, setProposalTypes] = useState([])
  const [followerList, setFollowerList] = useState([])
  const [reasonForLeaving, setReasonForLeaving] = useState('')
  const [overtime, setOvertime] = useState('')
  const [approvalLevels, setApprovalLevels] = useState([])
  const [approvalTemplateList, setApprovalTemplateList] = useState(null)

  const [form] = Form.useForm()
  const proposalTypeFiledValueWatched = Form.useWatch('proposal_type', form)

  const proposalTypeById = (proposalTypes || []).find(
    item => item.id === proposalTypeFiledValueWatched
  )

  const { content } = contentTemplateStore

  const EDITOR_REF = useRef()

  const loadApprovalTemplateList = async () => {
    try {
      await approvalTemplateStore.getApprovalTemplateLists()
    } catch (error) {
      console.log(error)
      message.error(error.vi || 'Có lỗi xảy ra, vui lòng thử lại!')
    }
  }

  useEffect(() => {
    ;(async () => {
      await loadApprovalTemplateList()
      setApprovalTemplateList(approvalTemplateStore.approvalTemplateLists)
    })()
  }, [])

  //Lấy approvalLevels
  const getApprovalLevelTemplate = async code => {
    try {
      const response = await approvalTemplateStore.getApprovalLevelTemplateByATCode(
        code
      )
      const approvalLevelsChange = response.data.map(
        (approvalLevel, index) => ({
          status: index === 0 ? 'CREATED' : 'WAITING',
          allow_edit: approvalLevel.allow_edit,
          code: approvalLevel.code,
          isDeleted: approvalLevel.isDeleted,
          level: approvalLevel.level,
          name: approvalLevel.name,
          username: approvalLevel.username,
        })
      )

      setApprovalLevels(approvalLevelsChange)
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    }
  }

  const [arrSubmissionMenu, setArrSubmissionMenu] = useState([])
  const showSubmissionMenu = useMemo(() => {
    return arrSubmissionMenu?.length >= 3 ? (
      arrSubmissionMenu?.map((unit, index) => {
        return (
          <OptGroup
            label={
              <b
                style={{
                  fontSize: 15,
                  fontWeight: 500,
                  color: '#000',
                }}>
                {unit.name_group}
              </b>
            }
            key={unit.id_group}>
            {unit?.child
              ?.filter(
                item =>
                  item.id_child !== 'OVERTIME_DAYOFF' &&
                  item.id_child !== 'OVERTIME_HOLIDAY' &&
                  item.id_child !== 'LEAVE_NO_SALARY' &&
                  item.id_child !== 'LEAVE_ANNUAL'
              )
              .map(child => {
                return (
                  <Option value={child.id_child} key={child.id_child}>
                    {child.name_child}
                  </Option>
                )
              })}
          </OptGroup>
        )
      })
    ) : (
      <></>
    )
  }, [arrSubmissionMenu])

  useEffect(() => {
    ;(async () => {
      const response = await proposalTypeStore.getProposalTypes()
      setProposalTypes(response.data)
      const newProposalTypes = [
        {
          id_group: '3',
          name_group: 'Hành chính - Khác',
          child: response.data
            .filter(item => item.id.includes('OTHER_'))
            .map(item => ({
              id_child: item.id,
              name_child: item.name,
            })),
        },
      ]
      const updatedSubmissionMenu = submissionMenu.concat(newProposalTypes)
      setArrSubmissionMenu(updatedSubmissionMenu)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const defaultProposalType = proposalTypes.find(
      item => item.id === 'BUSINESS_TRIP'
    )

    form.setFieldValue('proposal_type', defaultProposalType?.id)
  }, [proposalTypes, form])

  const [
    selectedApproveTemplateCode,
    setSelectedApproveTemplateCode,
  ] = useState('')
  // tìm item cuối cùng thỏa mãn điều kiện
  const findLastTemplate = (array, conditionFunction) => {
    for (let i = array?.length - 1; i >= 0; i--) {
      if (conditionFunction(array[i])) {
        return array[i]
      }
    }
    return undefined
  }

  useEffect(() => {
    ;(async () => {
      if (proposalTypeById?.approvalTemplateDTO == null) {
        if (approvalTemplateList?.length > 0) {
          const template = findLastTemplate(
            approvalTemplateList,
            template => template.approval_levels?.length === 3
          )
          if (template) {
            setSelectedApproveTemplateCode(template.code)
            await getApprovalLevelTemplate(template.code)
          } else {
            setApprovalLevels([])
          }
        } else {
          setApprovalLevels([])
        }
      } else if (
        approvalTemplateList?.some(
          item => item.code === proposalTypeById?.approvalTemplateDTO?.code
        )
      ) {
        setSelectedApproveTemplateCode(
          proposalTypeById?.approvalTemplateDTO?.code
        )
        await getApprovalLevelTemplate(
          proposalTypeById?.approvalTemplateDTO?.code
        )
      } else {
        const template = findLastTemplate(
          approvalTemplateList,
          template => template.approval_levels?.length === 3
        )
        if (template) {
          setSelectedApproveTemplateCode(template.code)
          await getApprovalLevelTemplate(template.code)
        } else {
          setApprovalLevels([])
        }
      }
    })()
  }, [authenticationStore.currentUser, approvalTemplateList, proposalTypeById])

  useEffect(() => {
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  /** Xử lý thay đổi file upload */
  const handleChangeFile = useCallback(
    info => {
      const filteredFileList = info.fileList.filter(
        (elem, index, fileArray) =>
          fileArray.findIndex(file => file.name === elem.name) === index
      )
      setFileList(filteredFileList)
    },
    [fileList]
  )

  const onFinish = async values => {
    try {
      loadingAnimationStore.showSpinner(true)
      let hasWarning = false
      proposalStore.defaultApprovalConfigUpdate.approvalLevels.forEach(item => {
        if (!item?.username) {
          message.warning(`Hãy chọn ${item.name}!`)
          hasWarning = true
        }
      })
      if (values.title.trim() == '') {
        message.warning(`Hãy nhập tiêu đề!`)
        hasWarning = true
      }
      if (hasWarning) return
      let fromDate =
        values?.date_picker && values?.date_picker.length == 2
          ? moment(values?.date_picker[0]).format(ISO_DATE_FORMAT)
          : ''
      let toDate =
        values?.date_picker && values?.date_picker.length == 2
          ? moment(values?.date_picker[1]).format(ISO_DATE_FORMAT)
          : ''
      const approvalLevels = proposalStore.defaultApprovalConfigUpdate.approvalLevels.map(
        (approvalLevel, index) => ({
          status: index === 0 ? 'CREATED' : 'WAITING',
          allow_edit: approvalLevel.allow_edit,
          code: approvalLevel.code,
          isDeleted: approvalLevel.is_deleted,
          level: approvalLevel.level,
          name: approvalLevel.name,
          username: approvalLevel.username,
        })
      )
      const submitValues = {
        ...values,
        title: values.title.replace(/\s+/g, ' ').trim(),
        proposal_type: proposalTypeById?.id,
        followers: followerList.map(el => el.id),
        reason: EDITOR_REF?.current?.editor?.getData(),
        reason_for_leaving: reasonForLeaving,
        type_of_leave: values?.type_of_leave,
        from_date: fromDate,
        to_date: toDate,
        proposalTimeList: proposalTimeList,
        overtime: overtime,
        approval_levels: approvalLevels.map(item => ({
          level: item.level,
          name: item.name,
          username: item.username,
          allow_edit: item.allow_edit,
          status:
            item.level === currentStep + 1
              ? PROPOSAL_STATUS.PENDING
              : item.status,
        })),
      }
      const uploadFileList =
        submitValues.file_ids && submitValues.file_ids.fileList
          ? submitValues.file_ids.fileList.map(file => file.originFileObj)
          : []
      const batchUploadArr = []
      uploadFileList.forEach(file => {
        const formData = new FormData()
        formData.append('file', file)
        batchUploadArr.push(fileStore.uploadFile(formData))
      })
      let uploadedFiles = []
      const response = await Promise.all(batchUploadArr)
      uploadedFiles = response.map(response => response.data.file_id)
      submitValues.file_ids = uploadedFiles

      await proposalStore.createOther(submitValues)

      message.success('Tạo mới thành công!')

      form.resetFields()
      history.push('/proposal')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }
  useEffect(() => {
    contentTemplateStore.load()
    contentTemplateStore.getDetails(proposalTypeById?.contentKey)
    setReasonForLeaving('')
    setOvertime('')
    form.setFieldsValue({
      type_of_leave: null,
      date_picker: null,
    })
    setProposalTimeList([])
    return () => {
      contentTemplateStore.clear()
    }
  }, [proposalTypeById])

  const onChangeApprovalTemplate = async value => {
    setSelectedApproveTemplateCode(value)
    await getApprovalLevelTemplate(value)
  }

  const [selectedDates, setSelectedDates] = useState([])
  const [proposalTimeList, setProposalTimeList] = useState([])

  const handleShiftChange = (value, recordKey) => {
    const updatedWorkDays = proposalTimeList.map(day =>
      day.key === recordKey ? { ...day, shift: value } : day
    )
    setProposalTimeList(updatedWorkDays)
  }

  const handleModeChange = (value, recordKey) => {
    let modeTypeValue = 0

    if (value === MODES.WOMEN.key) {
      modeTypeValue = 0.5
    } else if (value === MODES.CHILD_CARE.key) {
      modeTypeValue = 1
    }

    const updatedWorkDays = proposalTimeList.map(day =>
      day.key === recordKey
        ? { ...day, mode: value, mode_type: modeTypeValue }
        : day
    )
    setProposalTimeList(updatedWorkDays)
  }

  const handleModeTypeChange = (value, recordKey) => {
    const updatedWorkDays = proposalTimeList.map(day =>
      day.key === recordKey ? { ...day, mode_type: value } : day
    )
    setProposalTimeList(updatedWorkDays)
  }

  const handleNoteChange = (value, recordKey) => {
    const updatedWorkDays = proposalTimeList.map(day =>
      day.key === recordKey ? { ...day, note: value } : day
    )
    setProposalTimeList(updatedWorkDays)
  }

  const handleDateChange = (value, dates) => {
    setSelectedDates(dates)
  }

  // Trả về mảng của các ngày trong khoảng startDate đến endDate
  function getRange(startDate, endDate) {
    let fromDate = moment(startDate, 'DD/MM/YYYY')
    let toDate = moment(endDate, 'DD/MM/YYYY')
    let diff = toDate.diff(fromDate, 'days')
    let range = []

    for (let i = 0; i <= diff; i++) {
      let currentDay = moment(startDate, 'DD/MM/YYYY').add(i, 'days')
      if (proposalTypeById?.id === 'OVERTIME_NORMAL') {
        range.push(currentDay)
      } else {
        if (currentDay.day() !== 6 && currentDay.day() !== 0) {
          range.push(currentDay)
        }
      }
    }

    return range
  }

  const generateWorkDays = () => {
    const workDays = []
    const dateRange = getRange(selectedDates[0], selectedDates[1])
    if (dateRange?.length > 0) {
      if (proposalTypeById?.id === 'LEAVE_ABNORMAL') {
        dateRange.forEach((date, index) => {
          workDays.push({
            key: index.toString(),
            date: date,
            shift: 'morning',
            mode: 'normal',
            mode_type: 0,
            note: null,
          })
        })
      } else {
        dateRange.forEach((date, index) => {
          workDays.push({
            key: index.toString(),
            date: date,
            shift: 'allDay',
            mode: 'normal',
            note: null,
          })
        })
      }
      setProposalTimeList(workDays)
    } else {
      setProposalTimeList([])
    }
  }

  useEffect(() => {
    selectedDates?.length > 0 && generateWorkDays()
  }, [selectedDates])

  const columns = [
    {
      title: 'Ngày làm việc',
      dataIndex: 'date',
      key: 'date',
      render: text => <span>{moment(text).format('DD/MM/YYYY')}</span>,
    },
    {
      title: 'Buổi làm việc',
      dataIndex: 'shift',
      key: 'shift',
      render: (text, record) => (
        <Select
          style={{
            width: '120px',
          }}
          defaultValue={text}
          value={text}
          onChange={value => handleShiftChange(value, record.key)}>
          <Option value={SHIFTS.ALL_DAY.key}>{SHIFTS.ALL_DAY.value}</Option>
          <Option value={SHIFTS.MORNING.key}>{SHIFTS.MORNING.value}</Option>
          <Option value={SHIFTS.AFTERNOON.key}>{SHIFTS.AFTERNOON.value}</Option>
          <Option value={SHIFTS.EMPTY.key}>{SHIFTS.EMPTY.value}</Option>
        </Select>
      ),
    },
    ...(proposalTypeById?.id !== 'BUSINESS_TRIP' &&
    proposalTypeById?.id !== 'OVERTIME_NORMAL'
      ? [
          {
            title: 'Loại nghỉ phép',
            dataIndex: 'mode',
            key: 'mode',
            render: (text, record) => (
              <Select
                style={{
                  width: '120px',
                }}
                defaultValue={text}
                onChange={value => handleModeChange(value, record.key)}>
                <Option value={MODES.NORMAL.key}>{MODES.NORMAL.value}</Option>
                <Option value={MODES.SPECIAL.key}>{MODES.SPECIAL.value}</Option>
              </Select>
            ),
          },
        ]
      : []),
    ...(proposalTypeById?.id === 'OVERTIME_NORMAL'
      ? [
          {
            title: 'Giờ',
            dataIndex: 'mode_type',
            key: 'mode_type',
            width: '150px',
            render: (text, record) => {
              return (
                <InputNumber
                  style={{ width: '90px' }}
                  defaultValue={0}
                  min={0}
                  // max={8}
                  onChange={value => handleModeTypeChange(value, record.key)}
                />
              )
            },
          },
        ]
      : []),
    {
      title: 'Ghi chú',
      dataIndex: 'note',
      key: 'note',
      render: (text, record) => (
        <Input
          value={text}
          onChange={e => handleNoteChange(e.target.value, record.key)}
          placeholder="Nhập ghi chú"
        />
      ),
    },
  ]

  const leaveAbnormalColumns = [
    {
      title: 'Ngày làm việc',
      dataIndex: 'date',
      key: 'date',
      render: text => <span>{moment(text).format('DD/MM/YYYY')}</span>,
    },
    {
      title: 'Buổi làm việc',
      dataIndex: 'shift',
      key: 'shift',
      render: (text, record) => (
        <Select
          style={{
            width: '120px',
          }}
          defaultValue={text}
          // value={text}
          onChange={value => handleShiftChange(value, record.key)}>
          <Option value={SHIFTS.MORNING.key}>{SHIFTS.MORNING.value}</Option>
          <Option value={SHIFTS.AFTERNOON.key}>{SHIFTS.AFTERNOON.value}</Option>
          <Option value={SHIFTS.EMPTY.key}>{SHIFTS.EMPTY.value}</Option>
        </Select>
      ),
    },
    {
      title: 'Loại nghỉ phép',
      dataIndex: 'mode',
      key: 'mode',
      render: (text, record) => (
        <Select
          style={{
            width: '160px',
          }}
          defaultValue={text}
          onChange={value => handleModeChange(value, record.key)}>
          <Option value={MODES.NORMAL.key}>{MODES.NORMAL.value}</Option>
          <Option value={MODES.WOMEN.key}>{MODES.WOMEN.value}</Option>
          <Option value={MODES.CHILD_CARE.key}>{MODES.CHILD_CARE.value}</Option>
          <Option value={MODES.WORK_REASON.key}>
            {MODES.WORK_REASON.value}
          </Option>
          <Option value={MODES.BY_REGIME.key}>{MODES.BY_REGIME.value}</Option>
        </Select>
      ),
    },
    {
      title: 'Thời gian (giờ)',
      dataIndex: 'mode_type',
      key: 'mode_type',
      width: '150px',
      render: (text, record) => {
        switch (record.mode) {
          case MODES.NORMAL.key:
          case MODES.WORK_REASON.key:
          case MODES.BY_REGIME.key:
            return (
              <InputNumber
                style={{ width: '90px' }}
                defaultValue={0}
                min={0}
                max={8}
                onChange={value => handleModeTypeChange(value, record.key)}
              />
            )
          case MODES.WOMEN.key:
            return <span>0.5</span>
          case MODES.CHILD_CARE.key:
            return <span>1</span>
          default:
            return null
        }
      },
    },
    {
      title: 'Ghi chú',
      dataIndex: 'note',
      key: 'note',
      width: '250px',
      render: (text, record) => (
        <Input
          value={text}
          onChange={e => handleNoteChange(e.target.value, record.key)}
          placeholder="Nhập ghi chú"
        />
      ),
    },
  ]

  const approvalTemplateListTypeProposal = approvalTemplateList?.filter(
    item => item.templateType === 'proposal'
  )

  return (
    <Form
      scrollToFirstError={true}
      form={form}
      name={'phieu-trinh-khac-form'}
      layout={'vertical'}
      onFinish={onFinish}>
      <div
        style={{
          minHeight: '100dvh',
        }}>
        <div
          style={{
            display: 'flex',
            gap: 24,
          }}>
          <div style={{ flex: 1, minWidth: 0, height: 'fit-content' }}>
            <div className="custom-create-page-content-wrapper">
              <h3 style={{ marginBottom: 16, fontSize: 18, fontWeight: 600 }}>
                Thông tin chung
              </h3>

              <Row gutter={[20, 10]}>
                <Col span={12}>
                  <Form.Item
                    name="proposal_type"
                    label="Loại"
                    rules={[
                      {
                        required: true,
                        message: 'Vui lòng chọn loại hành chính',
                      },
                    ]}>
                    <Select
                      className="h-40"
                      style={{ width: '100%' }}
                      placeholder="Chọn loại"
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option?.children
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      }>
                      {showSubmissionMenu}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name={'title'}
                    label={'Tiêu đề'}
                    rules={[
                      {
                        required: true,
                        message: 'Vui lòng nhập tiêu đề',
                        whitespace: true,
                      },
                      {
                        max: 500,
                        message: 'Tiêu đề không được dài quá 500 kí tự!',
                      },
                    ]}>
                    <Input
                      placeholder="Nhập tiêu đề"
                      className="h-40"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name={'date_picker'}
                    label={'Thời gian:'}
                    rules={[
                      { required: true, message: 'Vui lòng chọn thời gian' },
                    ]}>
                    <RangePicker
                      format={DATE_FORMAT_LIST}
                      onChange={handleDateChange}
                      className="h-40"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <label
                    style={{
                      display: 'inline-block',
                      margin: '15px 8px 25px 0',
                    }}>
                    Người theo dõi:
                  </label>

                  <Space>
                    <Tooltip title="Chọn người dùng" color={blue}>
                      <Button
                        className="select-user-icon-btn"
                        icon={<UserOutlined style={{ color: blue }} />}
                        onClick={() =>
                          handleOpenSelectUserDepartmentPopup(
                            ASSIGNEE_TYPE.FOLLOWER
                          )
                        }
                      />
                    </Tooltip>
                  </Space>

                  <SelectList>
                    {followerList.map(el => (
                      <Tag
                        className={'tag-selected'}
                        color={'blue'}
                        key={el.id}
                        closable
                        onClose={() =>
                          selectPeopleStore.handleRemoveSelect(el)
                        }>
                        <AvatarHasName
                          imgId={el.image_id}
                          size={22}
                          name={el.full_name}
                          icon={
                            (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                              <BankOutlined />
                            )) ||
                            (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                              <TeamOutlined />
                            ))
                          }
                        />
                      </Tag>
                    ))}
                  </SelectList>
                </Col>

                {(proposalTypeById?.id === 'LEAVE' ||
                  proposalTypeById?.id === 'BUSINESS_TRIP' ||
                  proposalTypeById?.id === 'RETIMEKEEPING' ||
                  proposalTypeById?.id === 'OVERTIME_NORMAL' ||
                  proposalTypeById?.id === 'LEAVE_ABNORMAL') &&
                  proposalTimeList?.length > 0 && (
                    <Col span={24} style={{ marginBottom: '20px' }}>
                      <AppTable
                        pagination={false}
                        columns={
                          proposalTypeById?.id === 'LEAVE_ABNORMAL'
                            ? leaveAbnormalColumns
                            : columns
                        }
                        dataSource={proposalTimeList}
                      />
                    </Col>
                  )}
              </Row>
            </div>

            <Tabs
              defaultActiveKey="1"
              destroyInactiveTabPane={false}
              style={{
                marginTop: 20,
              }}>
              <Tabs.TabPane tab="Nội dung" key="1" forceRender>
                <Form.Item label={'Nội dung:'} name={'content'}>
                  <RichEditor
                    EDITOR_REF={EDITOR_REF}
                    placeholder={'Nhập nội dung...'}
                    editorContent={content && content}
                  />
                </Form.Item>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Tài liệu đính kèm" key="2" forceRender>
                <Form.Item label={'Tài liệu đính kèm:'} name={'file_ids'}>
                  <Upload.Dragger
                    valuePropName={'fileList'}
                    fileList={fileList}
                    multiple={true}
                    onChange={handleChangeFile}
                    beforeUpload={() => false}
                    className="custom-dragger-upload bg-white">
                    <DraggerUploadButton />
                  </Upload.Dragger>
                </Form.Item>
              </Tabs.TabPane>
            </Tabs>
          </div>

          <div
            className="custom-create-page-content-wrapper"
            style={{ width: 372, flexShrink: 0, height: 'fit-content' }}>
            <h3 style={{ marginBottom: 16, fontSize: 18, fontWeight: 600 }}>
              Thông tin bổ sung
            </h3>
            <div style={{ marginBottom: 20 }}>
              <p style={{ marginBottom: 8 }}> Chọn cấp duyệt</p>
              <Select
                className="h-40"
                style={{ width: '100%' }}
                showSearch
                placeholder="Chọn cấp duyệt"
                optionFilterProp="children"
                onChange={onChangeApprovalTemplate}
                filterOption={(input, option) =>
                  (option?.children ?? '')
                    ?.toLowerCase()
                    .includes(input.toLowerCase())
                }
                value={selectedApproveTemplateCode}>
                {approvalTemplateListTypeProposal &&
                  approvalTemplateListTypeProposal.map(item => (
                    <Select.Option key={item.code} value={item.code}>
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            </div>
            <ProposalStepApproveV2
              approvalLevelList={approvalLevels}
              isCheckedFirstStep
            />
          </div>
        </div>
      </div>

      <div className="custom-create-page-footer-sticky">
        <Button
          danger
          className="custom-ant-button w-160"
          onClick={() => {
            history.push('/proposal')
          }}>
          Hủy
        </Button>
        <Button
          className="custom-ant-button w-160"
          type={'primary'}
          htmlType={'submit'}>
          Tạo mới
        </Button>
      </div>

      <SelectPeoplePopup
        noLoadSelectData
        disableSelectDepartment
        isOpenCollapse={true}
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
        isUserDisableList={false}
      />
    </Form>
  )
}

export default inject(
  'leavePageStore',
  'proposalStore',
  'authenticationStore',
  'fileStore',
  'loadingAnimationStore',
  'selectUserStore',
  'selectPeopleStore',
  'contentTemplateStore',
  'approvalTemplateStore',
  'proposalTypeStore'
)(observer(OtherSubmissionFormV2))
